<template>
  <div>
    <a-menu v-model:selectedKeys="selectedKeys" :open-keys="openKeys" theme="light" mode="inline">
      <a-menu-item key="dashboard">
        <router-link to="/">
          <DesktopOutlined />
          <span>工作台</span>
        </router-link>
      </a-menu-item>
      <a-sub-menu key="article_category" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>文章管理</template>
        <a-menu-item key="/articleCategory">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/articleCategory">文章分类</router-link>
        </a-menu-item>
        <a-menu-item key="/article">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/article">文章列表</router-link>
        </a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="product_category" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>产品管理</template>
        <a-menu-item key="/productCategory">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/productCategory">产品分类</router-link>
        </a-menu-item>
        <a-menu-item key="/product">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/product">产品列表</router-link>
        </a-menu-item>

      </a-sub-menu>

      <a-sub-menu key="ad_category" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>轮播广告</template>
        <a-menu-item key="/adCategory">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/adCategory">轮播组管理</router-link>
        </a-menu-item>
        <a-menu-item key="/ad">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/ad">管理轮播</router-link>
        </a-menu-item>

      </a-sub-menu>


      <a-sub-menu key="project" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>壁纸管理</template>
        <a-menu-item key="/project">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/project">壁纸管理</router-link>
        </a-menu-item>
        <a-menu-item key="/project/category">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/project/category">壁纸分类</router-link>
        </a-menu-item>

      </a-sub-menu>

      <a-sub-menu key="tag_category" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>标签管理</template>
        <a-menu-item key="/tagCategory">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/tagCategory">标签分类管理</router-link>
        </a-menu-item>

      </a-sub-menu>


      <a-sub-menu key="nav" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>导航菜单</template>
        <a-menu-item key="/nav">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/nav">导航菜单</router-link>
        </a-menu-item>

      </a-sub-menu>



      <a-sub-menu key="user" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>用户管理</template>
        <a-menu-item key="/user">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/user">用户列表</router-link>
        </a-menu-item>
      </a-sub-menu>



      <a-sub-menu key="system" @titleClick="titleClick">
        <template #icon><ProjectOutlined /></template>
        <template #title>系统管理</template>
        <a-menu-item key="/site">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/site">站点设置</router-link>
        </a-menu-item>
        <a-menu-item key="/admin">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/admin">管理员列表</router-link>
        </a-menu-item>

        <a-menu-item key="/system">
          <template #icon><SolutionOutlined /></template>
          <router-link to="/system">系统设置列表</router-link>
        </a-menu-item>

      </a-sub-menu>





    </a-menu>
  </div>
</template>

<script setup>
import {
  DesktopOutlined,
  ProjectOutlined, ProfileOutlined, SolutionOutlined,RetweetOutlined,AuditOutlined,
  DatabaseOutlined,
  ContainerOutlined,FileOutlined,SettingOutlined,
  TeamOutlined,UserSwitchOutlined,
  FileMarkdownOutlined,ControlOutlined,
  RollbackOutlined,
} from '@ant-design/icons-vue';
import {reactive, ref} from "vue";
import {getQueryString} from "@/utils/common";
const selectedKeys = ref([])
const openKeys = reactive(['workorder'])
//
const pathname = window.location.pathname
selectedKeys.value = [pathname]
console.log('window.location',pathname)
//查询上一级的key信息
const dataList = [
  {key:'article_category',path:'/articleCategory'},
  {key:'article_category',path:'/article'},
  {key:'product_category',path:'/productCategory'},
  {key:'product_category',path:'/product'},
  {key:'ad_category',path:'/adCategory'},
  {key:'ad_category',path:'/ad'},
  {key:'nav',path:'/nav'},
  {key:'user',path:'/user'},
  {key:'system',path:'/system'},
  {key:'system',path:'/site'},
  {key:'system',path:'/admin'},
  {key:'project',path:'/project'},
  {key:'project',path:'/project/category'},
  {key:'tag_category',path:'/tagCategory'},
]
const fIndex = dataList.findIndex(t=>t.path === pathname)
console.log('fIndex',fIndex)
if(fIndex >= 0){
  const fKey = dataList[fIndex]['key']
  let newKey = fKey
  if(fKey === '/store/task'){
    let typeParam = getQueryString('category_no')
    newKey = fKey+'?category_no='+typeParam
    console.log('newKey',newKey)
    Object.assign(openKeys, ['workorder',fKey,newKey]);
  }else {
    Object.assign(openKeys, ['workorder',newKey]);
  }
  console.log('fKey',fKey)

}
const titleClick = (e) => {
  console.log('titleClick',e)
}
</script>

<style scoped>

</style>